// import React, { Component } from 'react';
// import Highcharts from 'highcharts/highstock';
// import highcharts3d from 'highcharts/highcharts-3d';
// highcharts3d(Highcharts);
// export default class TicketDonut extends Component {
// 	calculateStartAngle = data => {
// 		const open = data[0];
// 		const closed = data[1];

// 		const amountOpen = open[1];
// 		const amountClosed = closed[1];
// 		const totalTickets = amountOpen + amountClosed;
// 		const angle = (amountOpen / totalTickets) * 360;
// 		return 90 - angle / 2;
// 	};
// 	componentDidMount() {
// 		const { id, data } = this.props;
// 		const startAngle = this.calculateStartAngle(data);
// 		Highcharts.chart(`donut-container-${id}`, {
// 			chart: {
// 				width: 250,
// 				height: 165,
// 				styledMode: true,
// 				type: 'pie',

// 				options3d: {
// 					enabled: true,
// 					alpha: 0,
// 					beta: 52,
// 				},
// 			},

// 			title: {
// 				text: '',
// 			},

// 			tooltip: {
// 				enabled: false,
// 			},
// 			plotOptions: {
// 				pie: {
// 					innerSize: 65,
// 					depth: 25,
// 					startAngle,
// 				},

// 				series: {
// 					edgeColor: '#ffffff',
// 					states: {
// 						inactive: {
// 							opacity: 1,
// 						},
// 					},
// 					dataLabels: {
// 						enabled: false,
// 					},
// 				},
// 			},

// 			series: [
// 				{
// 					name: 'Delivered amount',
// 					data,
// 				},
// 			],
// 		});
// 	}

// 	render() {
// 		const {id} = this.props;
// 		return <div id={`donut-container-${id}`}></div>;
// 	}
// }
